import { userCan, userHasFunction, userHasEveryFunctions } from '@/helpers/auth'

export default {
  methods: {
    userCan,
    userHasFunction,
    userHasEveryFunctions,
  },
}
